/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    stroke="currentColor"
    d="M11.526 7.5V8H21.75c.9665 0 1.75.7835 1.75 1.75v12c0 .9665-.7835 1.75-1.75 1.75H8.25c-.9665 0-1.75-.7835-1.75-1.75v-12C6.5 8.7835 7.2835 8 8.25 8h2.776V5.25c0-2.2535-1.7536-4.097-3.971-4.241l-.0082-.0005-.008-.0003-.2466-.008L6.784 1H5.25C2.9965 1 1.153 2.7536 1.009 4.971l-.0005.0081-.0003.0082-.008.2465L1 5.242V7.6234a.25.25 0 0 1-.4925.0616L.5 7.601V5.25C.5 2.7165 2.4837.646 4.9824.5074L5.2567.5H6.776c2.5335 0 4.604 1.9838 4.7426 4.4824l.0074.2744V7.5Zm3.4984 10.878-3.2012-3.2012a.2501.2501 0 0 1 .3047-.3918l.0647.054 2.3728 2.373.4111.4112.345-.468 3.3393-4.5303.001-.0012a.2498.2498 0 0 1 .349-.0488.2505.2505 0 0 1 .081.2962l-.0452.073-4.0222 5.4339ZM11.276 8.5H8.25C7.5596 8.5 7 9.0596 7 9.75v12c0 .6904.5596 1.25 1.25 1.25h13.5c.6904 0 1.25-.5596 1.25-1.25v-12c0-.6904-.5596-1.25-1.25-1.25H11.276Z"
  />,
  'GrantAccess'
);
